// ONBOARDING TUTORIAL

export const ONBOARDING_TUTORIAL_STRINGS = {
  btn: {
    skip: "Skip Intro",
  },
  title1:  "Student living, simplified",    
  title2:  "Meet your neighbors",
  title3:  "Make payments easily",
  title4:  "Schedule payments ahead",
  title5:  "Submit work requests",
  title6:  "Community rewards",
  descr1:  "Take advantage of all that your community has to offer. All of your information in located in one convenient place.",
  descr2:  "RSVP to the latest events at your residence. These are a great way to meet others who live around you.",
  descr3:  "Take care of all your rent payments within the app; say goodbye to writing checks & coming to the office.",
  descr4:  "Set up automatic payments and say goodbye to late payments and accidental charges.",
  descr5:  "Oh no, your light went out? Submit work requests quickly and easily with our app. Track the progress & know when stuff has been taken care of.",
  descr6: "We want you to stay engaged so we have provided access to your community rewards right in the app; link your account from the home page.",
};